export default "__VITE_ASSET__Bl7hEiZk__"